import { render } from "./newsShare.vue?vue&type=template&id=9db4e97c&scoped=true"
import script from "./newsShare.vue?vue&type=script&lang=js"
export * from "./newsShare.vue?vue&type=script&lang=js"

import "./newsShare.vue?vue&type=style&index=0&id=9db4e97c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db4e97c"]])

export default __exports__